import { Node, Socket } from 'rete'
import i18n from 'vue-i18n'

import {
  SocketsActionsTypes,
  SocketNames,
  CustomInput,
  CustomOutput,
} from '../../components/Socket'
import { CustomConnection } from '../Connections/CustomConnection'
import { IBaseData } from "./BaseNode/BaseNodeDataModel";
import { BaseNodeModel } from './BaseNode/BaseNodeModel'

const SOCKET_GROUP = new Socket('commonSocketGroup')

export default class CustomNode extends Node {
  static LastSocketId = 0
  static i18n: i18n

  nodeProps?: { [key: string]: unknown }

  declare data: IBaseData
  declare outputs: Map<string, CustomOutput>

  color: string | null = null

  mainOutput?: string
  /**
   * Массив для того, чтобы сохранить реактивность с UI соккетами.
   * Мап становится реактивным, только если дернуть его вручную.
   * Массив все выходы, кроме главного!
   * */
  arrOutputs: Array<CustomOutput> = []

  mainInput?: string

  dragged = false

  constructor(name: string, struct: BaseNodeModel, nodeProps?: { [key: string]: unknown }) {
    super(name)

    if (nodeProps) {
      this.nodeProps = nodeProps
    }

    this.position = [ struct.x, struct.y ]

    this.color = struct.color ?? null

    this.createMainSockets(struct, name)
  }

  inputConnectionsTotalValue() {
    let nodeTotal = 0

    for (const inputs of this.inputs.values()) {
      (inputs.connections as Array<CustomConnection>).forEach(c => nodeTotal += c.data?.statistics?.value ?? 0)
    }

    return nodeTotal
  }

  getModel(): BaseNodeModel {
    return {
      data: this.data.getData(),
      x: this.position[0],
      y: this.position[1],
      color: this.color,

      ...this.mainInput ? { input: Number(this.mainInput) } : {},
      ...this.mainOutput ? { output: Number(this.mainOutput) } : {},
    }
  }

  private createMainSockets({
                              output,
                              input
                            }: { output?: number, input?: number }, nodeType: string): void {
    if (input !== undefined) {
      this.mainInput = String(input)
      this.addInput(new CustomInput(String(input), SocketNames.MainInput, SOCKET_GROUP, true))
    }

    if (output) {
      this.mainOutput = String(output)
      this.addOutput(new CustomOutput(String(output), nodeType === 'Start' ? SocketNames.StartOutput : SocketNames.MainOutput, SOCKET_GROUP, false))
    }
  }

  enableSockets(): void {
    this.enableInputs()
    this.enableOutputs()
  }

  private enableOutputs(): void {
    const size = this.outputs.size
    const iter = this.outputs.values()

    for (let i = 0; i < size; i++) {
      const socket = iter.next().value as CustomOutput
      socket.enable()
    }
  }

  private enableInputs(): void {
    const size = this.inputs.size
    const iter = this.inputs.values()

    for (let i = 0; i < size; i++) {
      const socket = iter.next().value as CustomInput
      socket.enable()
    }
  }

  disableSockets(sockets: 'inputs' | 'outputs', current: string): void {
    const size = this[sockets].size
    const iter = this[sockets].values()

    for (let i = 0; i < size; i++) {
      const socket = iter.next().value

      if (socket.key !== current) {
        socket.disable()
      } else {
        socket.select()
      }
    }
  }

  socketActions: SocketsActionsTypes = {
    createOutput:(output?: number, type: SocketNames = SocketNames.Default): number => {
      const socket = new CustomOutput(String(output ?? CustomNode.LastSocketId + 1), type, SOCKET_GROUP, false)
      this.arrOutputs.push(socket)
      this.addOutput(socket)

      if (!output) {
        CustomNode.LastSocketId += 1

        return Number(CustomNode.LastSocketId)
      } else {
        return output
      }
    },
    deleteOutput: (id: number): void => {
      const output = this.outputs.get(String(id))

      if (output) {
        super.removeOutput(output)
      }
    },
    checkOutput: (output: number): boolean => {
      return this.outputs.has(output.toString())
    },
    switchIsMoved: (id: number, state: boolean): void => {
      const output = this.outputs.get(String(id))

      if (output) {
        output.isMoved = state
      }
    }
  }

  /**В зависимости от надобности метод переназначается в каждый ноде отдельно*/
  isValid(): boolean {
    return true
  }

  getOutput(output: number): CustomOutput | undefined {
    return this.arrOutputs.find((o) => o.key === output.toString())
  }

  static removeButtonOutput(node: CustomNode, outputs: Array<{ output?: number }>): Promise<void> {
    outputs.forEach(({ output }) => {
      if (output) {
        const buttonOutput = node.outputs.get(String(output))

        if (buttonOutput) {
          buttonOutput.connections.forEach((c) => buttonOutput.removeConnection(c))

          node.removeOutput(buttonOutput)
        }
      }
    })
    return Promise.resolve()
  }
}
